var animateButton = function(e) {

  e.preventDefault;
  //reset animation
  e.target.classList.remove('animate');

  e.target.classList.add('animate');
  setTimeout(function(){
    e.target.classList.remove('animate');
  },700);
};

var bubblyButtons = document.getElementsByClassName("Button");

for (var i = 0; i < bubblyButtons.length; i++) {
  bubblyButtons[i].addEventListener('hover', animateButton, false);
}

$(".ProductMeta__Variants--showMore").click(function(){
  $(".hide").removeClass("hide");
	$(".ProductMeta__Variants--showMore").addClass("remove");
});

var agreementCheckbox = '#agreementCheckbox';
var agreementNewsletterCheckbox = '#agreementNewsletterCheckbox';

$(document).ready(function() {

  $('body').on('click', '#Subscribe', function(ev) {

    if ($(agreementNewsletterCheckbox).is(':checked')) {
      $(this).submit();
    }
    else {
      alert(window.languages.newsletterAgreeAlert);
      return false;
    }
  });
});


/// Quickbuy

window.quickBuyOpen = function(event) {

  $('.QuickBuy').removeClass('is-active');

  // Get references to our key dom elements.
  var quickBuyBtn = $(event.target);
  var quickBuy = $(quickBuyBtn).parent();
  var quickBuyVariants = $(event.target).next();

  // Cancel the default event as this is not a true
  // link action.
  event.preventDefault();

  // Check to see if the footer is currently animating.
  // If it is, then we don't want to listen to this
  // click as it might be a double-click.
  if (quickBuyVariants.is( ":animated" )){
    return;
  }

  // Clear any existing timer since the user clearly
  // want to interact with the footer.
  clearInactiveTimer();

  // Call the open footer.
  openFooter();

  // Set the inactive timer.
  setInactiveTimer();


	// Attach a mouse enter handler on the footer to hook into
	// user interaction. If the user mouses over the footer,
	// then we want to remove any timers.
	quickBuyVariants.mouseenter(
		function(){
			// Check to see if the footer is currently
			// animating. If it is, then let's ignore since
			// we are not wired to stop closing mid-animation.
			if (quickBuyVariants.is( ":animated" )){
				return;
			}

			// First, clear any existing timer that might take
			// control of the footer display.
			clearInactiveTimer();
		}
	);


	// Attach a mouse exit handler on teh footer to hook into
	// user disinterest. If the user mouses out of the footer,
	// then we want to start thinking about closing it.
	quickBuyVariants.mouseleave(
		function(){
			// Check to see if the footer is currently
			// animating. If it is, then let's ignore since
			// we are not wired to stop closing mid-animation.
			if (quickBuyVariants.is( ":animated" )){
				return;
			}

			// Set inactivity timer for future-close.
			setInactiveTimer();
		}
	);


  // Create a function that sets an inactive timer on the
  // footer. This will be called when the footer is opened
  // or when the user mouses out of the footer.
  function setInactiveTimer(){
    // We are goint to store this timer as a property of
    // the footer itself.
    quickBuy.data(
      "inactiveTimer",
      setTimeout( closeFooter, (4 * 1000) )
    );
  }


  // I remove any inactive timer on the footer.
  function clearInactiveTimer(){
    clearTimeout( quickBuy.data( "inactiveTimer" ) );
  }


  // I open the footer.
  function openFooter(){
    // Open the footer.
    quickBuy.addClass('is-active');
  }


  // I close the footer.
  function closeFooter(){
    // Slide the footer up (to close it).
    quickBuy.removeClass('is-active');
  }


}

window.openQuickBuyMobile = function(id) {
  if (window.currentlyOpenQuickBuy != undefined) {
    window.currentlyOpenQuickBuy.classList.remove('is-active');
  }
  var targetQuickBuyEl = document.querySelector('[data-quickbuy-id="' + id + '"]');
  console.log(targetQuickBuyEl);
  if (targetQuickBuyEl != undefined) {
    targetQuickBuyEl.classList.add('is-active');
    window.currentlyOpenQuickBuy = targetQuickBuyEl;
  }
}

window.closeQuickBuyMobile = function() {
  if (window.currentlyOpenQuickBuy != undefined) {
    window.currentlyOpenQuickBuy.classList.remove('is-active');
  }
}

window.addToCart = function(variant, event) {
  event.target.classList.remove('added');
  event.target.classList.add('loading');
  Shopify.addItem(variant, 1, function(res) {
    event.target.classList.remove('loading');
    event.target.classList.add('added');

    setTimeout(function () {
      event.target.classList.remove('added');
      if(window.cartChanged) {
        window.cartChanged();
      }
    }, 1000);


    setTimeout(function () {
      $('.Drawer__Main--cart').scrollTop(0);

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variant,
          quantity: 1
        }
      }));
    }, 1000);
  }, function(res) {
    setTimeout(function () {
      event.target.classList.remove('loading');
    }, 1000);
  });
}


// api.jquery.min.js

function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="${{amount}}",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var o=[];return jQuery.each(t,function(e,t){jQuery.each(t,function(t,r){o.push(e+" "+r)})}),o},Shopify.onCartUpdate=function(t){alert("There are now "+t.item_count+" items in the cart.")},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function n(t,r){return void 0===t?r:t}function e(t,r,e,o){if(r=n(r,2),e=n(e,","),o=n(o,"."),isNaN(t)||null==t)return 0;var a=(t=(t/100).toFixed(r)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?o+a[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",a=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(a)[1]){case"amount":o=e(t,2);break;case"amount_no_decimals":o=e(t,0);break;case"amount_with_comma_separator":o=e(t,2,".",",");break;case"amount_with_space_separator":o=e(t,2," ",",");break;case"amount_with_period_and_space_separator":o=e(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=e(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=e(t,0,".","");break;case"amount_with_space_separator":o=e(t,2,",","");break;case"amount_with_apostrophe_separator":o=e(t,2,"'",".")}return i.replace(a,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(o){return t}},Shopify.addItem=function(t,r,e){var o={type:"POST",url:"/cart/add.js",data:"quantity="+(r=r||1)+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:"/cart/add.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(r){jQuery.getJSON("/cart.js",function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)})},Shopify.pollForCartShippingRatesForDestination=function(o,a,t){t=t||Shopify.onError;var n=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(t,r,e){200===e.status?"function"==typeof a?a(t.shipping_rates,o):Shopify.onCartShippingRatesUpdate(t.shipping_rates,o):setTimeout(n,500)},error:t})};return n},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var o={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(o)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var o={type:"POST",url:"/cart/change.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.removeItem=function(t,r){var e={type:"POST",url:"/cart/change.js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(r){var t={type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(t)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:"/cart/update.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var o="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var e=attributeToString(r.key);""!==e&&(o+="attributes["+e+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){o+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var e={type:"POST",url:"/cart/update.js",data:o,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(t){var e=[],r=function(t,r){r=jQuery.isFunction(r)?r():r,e[e.length]=encodeURIComponent(t)+"="+encodeURIComponent(r)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){r(this.name,this.value)});else for(var o in t)Shopify.buildParams(o,t[o],r);return e.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(e,t,o){jQuery.isArray(t)&&t.length?jQuery.each(t,function(t,r){rbracket.test(e)?o(e,r):Shopify.buildParams(e+"["+("object"==typeof r||jQuery.isArray(r)?t:"")+"]",r,o)}):null!=t&&"object"==typeof t?Shopify.isEmptyObject(t)?o(e,""):jQuery.each(t,function(t,r){Shopify.buildParams(e+"["+t+"]",r,o)}):o(e,t)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});


$(document).ready(function() {
  // Check for sticky add to cart button
  const stickyAddToCartBtn = $('#AddToCart__Sticky .ProductForm__AddToCart');
  
  if (stickyAddToCartBtn.length) {  
    stickyAddToCartBtn.on('click', function(e) {
      // Check if data attribute is specifically set to "true"
      if (stickyAddToCartBtn[0].getAttribute('data-add-to-cart-trigger') !== "true") {  
        e.preventDefault();
          
        // Click on the first ProductForm__Item inside ProductForm__Option
        var firstProductFormItem = $(".ProductForm__Option .ProductForm__Item").first();
        if (firstProductFormItem.length) {
          firstProductFormItem.trigger("click");
        }
      }
    });
  }
});

// Thumbnail wrapper height
$(document).ready(function() {
    var wrapperHeight = $(".Product__Wrapper .flickity-viewport").height();
    console.log("Højde: " + wrapperHeight);
    $(".Product__SlideshowNav--thumbnails").css("height", wrapperHeight);
});
